<template>
    <div class="modal-content card dashboardGuidedTour">
        <div class="card-content has-text-centered">
            <h1 class="title is-2">Select Your Layout</h1>

            <div class="dashboardGuidedTour__layoutOptions">
                <layout-options />
            </div>
        </div>

        <div class="card-footer align-items-end">
            <div class="card-footer-item">
                <a href="#" @click.prevent="$emit('back')">
                    <icon-text icon="angle-left" position="is-left" class="is-mobile" dense>Previous</icon-text>
                </a>
            </div>

            <div class="card-footer-item">
                <a href="#" @click.prevent="$emit('finish')">
                    <icon-text icon="angle-right" position="is-right" class="is-mobile" dense>Dashboard</icon-text>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import LayoutOptions from '@/components/dashboard/personal-options/LayoutOptions.vue';
import IconText from '@/components/IconText.vue';

export default {
    name: 'DashboardGuidedTourStepThree',

    components: { IconText, LayoutOptions },

    emits: ['back', 'finish'],
};
</script>
